declare namespace $ {

	export class $mol_icon_folder extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=folder.view.tree.d.ts.map